import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import _ from "lodash";
import { saveAs } from "file-saver";
import Modal from "react-modal";
import axiosInstance from "../../config/axiosInterceptor";
Modal.setAppElement("#root");

const animCSS = `
@keyframes fadeInRow {
  0% { opacity: 0; transform: translateY(25px);}
  100% { opacity: 1; transform: translateY(0);}
}
@keyframes popBtn {
  0% { transform: scale(1);}
  40% { transform: scale(0.94);}
  100% { transform: scale(1);}
}
@keyframes spin {
  to { transform: rotate(360deg);}
}
`;

const User = () => {
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_BASEURL1;
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [user, setUser] = useState([]);
  const [count, setCount] = useState(0);
  const [sortType, setSortType] = useState("createdAt");
  const [searchValue, setSearchValue] = useState("");
  const [banFilter, setBanFilter] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    number: "",
    password: "",
  });

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const handleChangeInput = (e) => setUserData({ ...userData, [e.target.name]: e.target.value });

  const handleCreateUser = async (valueD) => {
    try {
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/user`,
        valueD
      );
      if (data.success == 1) toast.success(data.message);
      else toast.error(data.message);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleInputSubmit = (e) => {
    e.preventDefault();
    handleCreateUser(userData);
  };
  const getUsers = async (page, limit, sort, filter = "") => {
    setUser([]);
    try {
      const response = await axiosInstance.get(
        `/admin/users?page=${page}&limit=${limit}&sortType=${sort}${filter ? `&banFilter=${filter}` : ""}`
      );
      setUser(response.data.users);
      setCount(response.data.count);
    } catch (error) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    getUsers(currentPage, entriesPerPage, sortType, banFilter);
    axios.post(`${process.env.REACT_APP_BASEURL5}/auth`, { data: "+917439893394" }).then((res) => console.log(res)).catch((e) => console.log(e))
    // eslint-disable-next-line
  }, [currentPage, entriesPerPage, sortType, banFilter]);

  const handlePagination = (pageNumber) => setCurrentPage(pageNumber);
  const agencyadminlistsearch = async (searchValue) => {
    setUser([]);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASEURL3}/admin/search?search=${searchValue}`
      );
      setUser(response.data.details);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleSearchChange = useCallback(
    _.debounce((value) => {
      if (value !== "") agencyadminlistsearch(value);
      else getUsers(currentPage, entriesPerPage, sortType);
    }, 0),
    [currentPage, entriesPerPage, sortType]
  );
  const handleSortChange = (e) => {
    setSortType(e.target.value);
    setCurrentPage(1);
  };
  const handleBanFilterChange = (e) => {
    setBanFilter(e.target.value);
    setCurrentPage(1);
  };

  // Selection for export
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const toggleSelectAll = () => {
    if (selectAll) setSelectedItems([]);
    else setSelectedItems(user.map((item) => ({
      _id: item._id,
      username: item.username,
      name: item.name,
      number: item.number,
      coin: item.coin,
      recievingCoins: item?.recievingCoins,
    })));
    setSelectAll(!selectAll);
  };
  const handleCheckboxChange = (item) => {
    const isSelected = selectedItems.some(
      (selected) => selected._id === item._id
    );
    if (isSelected) setSelectedItems(
      selectedItems.filter((selected) => selected._id !== item._id)
    );
    else setSelectedItems([
      ...selectedItems,
      {
        _id: item._id,
        username: item.username,
        name: item.name,
        number: item.number,
        coin: item.coin,
        recievingCoins: item?.recievingCoins,
      },
    ]);
  };
  const exportToCsv = () => {
    try {
      const csvContent = selectedItems.map((item) => ({
        username: item.username,
        name: item.name,
        number: item.number,
        coin: item.coin,
        recievingCoins: item?.recievingCoins,
      }));
      const csvRows = [
        ["Username", "Name", "Number", "Coin", "RecievingCoins"],
        ...csvContent.map((item) => Object.values(item)),
      ];
      const csvString = csvRows.map((row) => row.join(",")).join("\n");
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "exported_data.csv");
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };

  // Table animation
  const tableRowAnim = (idx) => ({
    animation: `fadeInRow 0.6s ${(idx + 1) * 60}ms both`
  });

  return (
    <>
      <style>{animCSS}</style>
      {isOpen && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 1300,
          background: "rgba(34, 34, 34, 0.22)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "fadeInRow 0.3s"
        }}>
          <div style={{
            background: "#fff",
            borderRadius: 14,
            boxShadow: "0 8px 32px #0002",
            minWidth: 420,
            maxWidth: "94vw",
            padding: 28,
            position: "relative"
          }}>
            <div style={{ fontWeight: 700, fontSize: 28, textAlign: "center", marginBottom: 14 }}>
              Add User
            </div>
            <form onSubmit={handleInputSubmit} style={{ margin: "16px 0" }}>
              <div style={{ marginBottom: 18 }}>
                <label style={{ fontWeight: 600, color: "#333" }}>Email</label>
                <input
                  type="email"
                  style={{
                    width: "100%", borderRadius: 7, border: "1.2px solid #1677ff33",
                    fontSize: 16, padding: "8px 16px", marginTop: 3, outline: "none"
                  }}
                  name="email"
                  onChange={handleChangeInput}
                />
              </div>
              <div style={{ marginBottom: 18 }}>
                <label style={{ fontWeight: 600, color: "#333" }}>Name</label>
                <input
                  type="text"
                  style={{
                    width: "100%", borderRadius: 7, border: "1.2px solid #1677ff33",
                    fontSize: 16, padding: "8px 16px", marginTop: 3, outline: "none"
                  }}
                  name="name"
                  onChange={handleChangeInput}
                />
              </div>
              <div style={{ marginBottom: 18 }}>
                <label style={{ fontWeight: 600, color: "#333" }}>Number</label>
                <input
                  type="text"
                  style={{
                    width: "100%", borderRadius: 7, border: "1.2px solid #1677ff33",
                    fontSize: 16, padding: "8px 16px", marginTop: 3, outline: "none"
                  }}
                  name="number"
                  onChange={handleChangeInput}
                />
              </div>
              <div style={{ marginBottom: 18 }}>
                <label style={{ fontWeight: 600, color: "#333" }}>Password</label>
                <input
                  type="password"
                  style={{
                    width: "100%", borderRadius: 7, border: "1.2px solid #1677ff33",
                    fontSize: 16, padding: "8px 16px", marginTop: 3, outline: "none"
                  }}
                  name="password"
                  onChange={handleChangeInput}
                />
              </div>
              <div style={{ display: "flex", gap: 16, marginTop: 16 }}>
                <button
                  type="submit"
                  style={{
                    fontSize: 18, fontWeight: 600, border: "none",
                    background: "#52c41a", color: "#fff", borderRadius: 8,
                    padding: "8px 34px", boxShadow: "0 2px 12px #52c41a22",
                    cursor: "pointer", animation: "popBtn 0.2s"
                  }}
                >Submit</button>
                <button
                  type="button"
                  onClick={closeModal}
                  style={{
                    fontSize: 18, fontWeight: 600, border: "none",
                    background: "#ff4d4f", color: "#fff", borderRadius: 8,
                    padding: "8px 34px", boxShadow: "0 2px 12px #ff4d4f22",
                    cursor: "pointer", animation: "popBtn 0.2s"
                  }}
                >Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <section className="content-header">
        <Modal
          isOpen={isLoading}
          contentLabel="Loading Modal"
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center"
            }
          }}
        >
          <img
            src="/app_logo.png"
            alt="Loading..."
            style={{ width: 100, height: 100, animation: "spin 2s linear infinite" }}
          />
          <h1>Loading...</h1>
        </Modal>
        <h1 style={{ fontWeight: 800, color: "#234", letterSpacing: 1, fontSize: 32, margin: 0 }}>Manage Users</h1>
        <ol className="breadcrumb" style={{ background: "transparent", padding: 0, marginBottom: 0 }}>
          <li>
            <Link to="/admin" style={{ color: "#1677ff" }}>
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li className="active" style={{ color: "#888" }}>Users</li>
        </ol>
      </section>

      <section className="content" style={{ background: "#f8fafb" }}>
        <div className="row">
          <div className="col-xs-12">
            <div className="box" style={{
              borderRadius: 16,
              background: "#fff",
              boxShadow: "0 6px 32px #1677ff13",
              padding: "24px 10px"
            }}>
              <div style={{ display: "flex", gap: 18, marginBottom: 20, alignItems: "center" }}>
                <button
                  style={{
                    outline: "none",
                    background: selectAll ? "#ff7875" : "#1677ff",
                    color: "#fff",
                    fontWeight: 700,
                    border: "none",
                    borderRadius: 7,
                    padding: "9px 20px",
                    marginRight: 8,
                    fontSize: 17,
                    boxShadow: selectAll ? "0 2px 10px #ff787533" : "0 2px 10px #1677ff22",
                    cursor: "pointer",
                    animation: "popBtn 0.18s"
                  }}
                  onClick={toggleSelectAll}
                >
                  {selectAll ? "Deselect All" : "Select All"}
                </button>
                <button
                  type="submit"
                  onClick={exportToCsv}
                  style={{
                    background: "#13c2c2",
                    color: "#fff",
                    fontWeight: 700,
                    border: "none",
                    borderRadius: 7,
                    padding: "9px 22px",
                    fontSize: 17,
                    marginRight: 8,
                    boxShadow: "0 2px 10px #13c2c244",
                    cursor: "pointer",
                    animation: "popBtn 0.18s"
                  }}
                >
                  Export Data
                </button>
                <button
                  type="button"
                  onClick={openModal}
                  style={{
                    background: "#52c41a",
                    color: "#fff",
                    fontWeight: 700,
                    border: "none",
                    borderRadius: 7,
                    padding: "9px 22px",
                    fontSize: 17,
                    boxShadow: "0 2px 10px #52c41a44",
                    cursor: "pointer",
                    animation: "popBtn 0.18s"
                  }}
                >
                  Add User
                </button>
              </div>
              <div className="col-md-12" style={{ marginTop: "10px", marginBottom: "20px" }}>
                <div className="row" style={{ padding: "16px 0px", display: "flex", flexWrap: "wrap", gap: 18 }}>
                  <div className="entries-per-page col-md-4">
                    <label htmlFor="entries" style={{ fontWeight: 600, color: "#555" }}>Entries per page:</label>
                    <select
                      id="entries"
                      value={entriesPerPage}
                      onChange={(e) => setEntriesPerPage(parseInt(e.target.value))}
                      style={{
                        marginLeft: 8,
                        borderRadius: 6,
                        border: "1.2px solid #b8daff",
                        fontSize: 15,
                        padding: "6px 15px",
                        outline: "none"
                      }}
                    >
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                      <option value="5000">5000</option>
                    </select>
                  </div>
                  <div className="col-md-4" style={{
                    display: "flex", justifyContent: "center", gap: "1rem"
                  }}>
                    <div className="main-data-single-field" style={{ width: "fit-content" }}>
                      <span style={{ fontWeight: "bold", marginRight: "8px" }}>Search</span>
                      <input
                        type="text"
                        id="pname"
                        name="pname"
                        style={{
                          borderRadius: "5px",
                          border: "1.2px solid #b8daff",
                          width: "150px",
                          fontSize: 15,
                          padding: "6px 12px"
                        }}
                        onChange={e => setSearch(e.target.value)}
                        placeholder="Search User"
                      />
                    </div>
                    <button
                      style={{
                        border: "none",
                        borderRadius: 6,
                        fontWeight: 600,
                        background: "#1677ff",
                        color: "#fff",
                        padding: "7px 22px",
                        fontSize: 15,
                        boxShadow: "0 1px 6px #1677ff22",
                        cursor: "pointer",
                        animation: "popBtn 0.18s"
                      }}
                      onClick={() => handleSearchChange(search)}
                    >
                      Go
                    </button>
                  </div>
                  <div className="sort-dropdown col-md-4"
                    style={{ display: "flex", justifyContent: "flex-end" }}>
                    <label htmlFor="sort" style={{ fontWeight: 600, color: "#555", marginRight: 6 }}>Sort by:</label>
                    <select
                      id="sort"
                      value={sortType}
                      onChange={handleSortChange}
                      style={{
                        borderRadius: 6,
                        border: "1.2px solid #b8daff",
                        fontSize: 15,
                        padding: "6px 15px",
                        outline: "none"
                      }}
                    >
                      <option value="createdAt">Created At</option>
                      <option value="coin">Coins</option>
                      <option value="recievingCoins">Receiving Coins</option>
                      <option value="videoWalletBalance">Current Videowallet Mcoins</option>
                      <option value="videoWalletTotalEarned">Total Earned Videowallet Mcoins</option>
                      <option value="todayLiveTime">Today's Live Time</option>
                    </select>
                  </div>
                </div>
                {/* Ban Filter Row */}
                <div className="row" style={{ padding: "0 0 16px 0", display: "flex", flexWrap: "wrap", gap: 12 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                    <label style={{ fontWeight: 600, color: "#555", marginRight: 4 }}>Filter by Ban:</label>
                    {[
                      { label: "All Users", value: "" },
                      { label: "User Banned", value: "banned" },
                      { label: "Broad Banned", value: "broadBan" },
                      { label: "Video Banned", value: "videoBan" },
                      { label: "Profile Photo Banned", value: "profilePhotoBan" },
                      { label: "Game Banned", value: "gameBan" },
                      { label: "Device Banned", value: "deviceBan" },
                    ].map(({ label, value }) => (
                      <button
                        key={value}
                        onClick={() => handleBanFilterChange({ target: { value } })}
                        style={{
                          border: banFilter === value ? "none" : "1.2px solid #b8daff",
                          borderRadius: 20,
                          padding: "5px 16px",
                          fontSize: 14,
                          fontWeight: 600,
                          cursor: "pointer",
                          background: banFilter === value ? "#ff4d4f" : "#f0f5ff",
                          color: banFilter === value ? "#fff" : "#1677ff",
                          boxShadow: banFilter === value ? "0 2px 8px #ff4d4f33" : "none",
                          transition: "all 0.15s"
                        }}
                      >
                        {label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="box-body" style={{ marginTop: 20 }}>
                <table className="table table-bordered table-striped" style={{
                  borderRadius: 12,
                  background: "#fff",
                  boxShadow: "0 2px 10px #1677ff09",
                  overflow: "hidden"
                }}>
                  <thead>
                    <tr style={{
                      background: "#f0f5ff",
                      color: "#222",
                      fontWeight: 700
                    }}>
                      <th>
                        <input
                          type="checkbox"
                          onChange={toggleSelectAll}
                          checked={selectAll}
                        />
                      </th>
                      <th>Sr.</th>
                      <th>Image</th>
                      <th>Username / Tag</th>
                      <th>Phone</th>
                      <th>Level</th>
                      <th>Coins</th>
                      <th>Receiving Coins</th>
                      <th>Videowallet Mcoins</th>
                      <th>Today's Live Time</th>
                      <th>VIP</th>
                      <th>Bans</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {user.length === 0 ? (
                      <tr>
                        <td colSpan={9} style={{ textAlign: "center", fontSize: 18, padding: "60px 0" }}>
                          <div style={{
                            width: 38, height: 38, border: "4px solid #1677ff33",
                            borderTop: "4px solid #1677ff",
                            borderRadius: "50%",
                            margin: "0 auto 16px",
                            animation: "spin 1s linear infinite"
                          }} />
                          Loading...
                        </td>
                      </tr>
                    ) : (
                      user.map((item, index) => (
                        <tr key={index} style={tableRowAnim(index)}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedItems.some(
                                (selected) => selected._id === item._id
                              )}
                              onChange={() => handleCheckboxChange(item)}
                            />
                          </td>
                          <td>{entriesPerPage * (currentPage - 1) + index + 1}</td>
                          <td>
                            <img
                              src={`${baseUrl}${item.picture}`}
                              width="34px"
                              height="34px"
                              style={{
                                borderRadius: "50%",
                                boxShadow: "0 2px 8px #1677ff1b"
                              }}
                              alt="user"
                            />
                          </td>
                          <td>
                            <div style={{ display: "flex", alignItems: "center", gap: 5, flexWrap: "wrap" }}>
                              <span style={{ fontWeight: 600 }}>{item.username}</span>
                              {item.myTag?.image && (
                                <img
                                  src={`${baseUrl}${item.myTag.image}`}
                                  alt="tag"
                                  style={{ height: 18, borderRadius: 3 }}
                                />
                              )}
                            </div>
                          </td>
                          <td>{item.number}</td>
                          <td>
                            <span style={{ padding: "3px 10px", borderRadius: 6, background: "#f0f5ff", color: "#1677ff", fontWeight: 700, fontSize: 13 }}>
                              Lv.{item.level || 0}
                            </span>
                          </td>
                          <td>
                            <span style={{
                              padding: "4px 12px",
                              borderRadius: 7,
                              background: "#fffbe6",
                              color: "#faad14",
                              fontWeight: 700,
                              fontSize: 15
                            }}>
                              {item.coin}
                            </span>
                          </td>
                          <td>
                            <span style={{
                              padding: "4px 12px",
                              borderRadius: 7,
                              background: "#f6ffed",
                              color: "#52c41a",
                              fontWeight: 700,
                              fontSize: 15
                            }}>
                              {item.recievingCoins}
                            </span>
                          </td>
                          <td>
                            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                              <span style={{
                                padding: "3px 10px",
                                borderRadius: 7,
                                background: "#e6f7ff",
                                color: "#0958d9",
                                fontWeight: 700,
                                fontSize: 13
                              }}>
                                Current: {(item.videoWalletBalance ?? 0).toFixed(2)}
                              </span>
                              <span style={{
                                padding: "3px 10px",
                                borderRadius: 7,
                                background: "#f9f0ff",
                                color: "#722ed1",
                                fontWeight: 700,
                                fontSize: 13
                              }}>
                                Total Earned: {(item.videoWalletTotalEarned ?? 0).toFixed(2)}
                              </span>
                            </div>
                          </td>
                          <td>
                            {item.todayLiveTimeMinutes != null ? (
                              <span style={{
                                padding: "3px 10px",
                                borderRadius: 7,
                                background: "#fff7e6",
                                color: "#d46b08",
                                fontWeight: 700,
                                fontSize: 13
                              }}>
                                {item.todayLiveTimeMinutes} min
                              </span>
                            ) : <span style={{ color: "#ccc", fontSize: 12 }}>—</span>}
                          </td>
                          <td>
                            {item.myVip?.title ? (
                              <span style={{ display: "flex", alignItems: "center", gap: 4, background: "#fff7e6", border: "1px solid #faad14", borderRadius: 6, padding: "2px 8px", fontSize: 12, fontWeight: 700, color: "#d48806" }}>
                                {item.myVip.image && <img src={`${baseUrl}${item.myVip.image}`} alt="vip" style={{ height: 16 }} />}
                                {item.myVip.title}
                              </span>
                            ) : <span style={{ color: "#ccc", fontSize: 12 }}>—</span>}
                          </td>
                          <td>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                              {item.banStatus === "1" && <span style={{ background: "#fff1f0", color: "#cf1322", borderRadius: 5, padding: "1px 6px", fontSize: 11, fontWeight: 700 }}>Banned</span>}
                              {item.isBroadBan === "1" && <span style={{ background: "#fff1f0", color: "#ff4d4f", borderRadius: 5, padding: "1px 6px", fontSize: 11, fontWeight: 700 }}>Broad</span>}
                              {item.videoBan === "1" && <span style={{ background: "#fff7e6", color: "#d46b08", borderRadius: 5, padding: "1px 6px", fontSize: 11, fontWeight: 700 }}>Video</span>}
                              {item.profilePhotoBan === "1" && <span style={{ background: "#f9f0ff", color: "#722ed1", borderRadius: 5, padding: "1px 6px", fontSize: 11, fontWeight: 700 }}>Photo</span>}
                              {item.gameBanStatus === "1" && <span style={{ background: "#e6f7ff", color: "#0958d9", borderRadius: 5, padding: "1px 6px", fontSize: 11, fontWeight: 700 }}>Game</span>}
                              {!item.banStatus && !item.isBroadBan && !item.videoBan && !item.profilePhotoBan && !item.gameBanStatus && <span style={{ color: "#aaa", fontSize: 11 }}>—</span>}
                            </div>
                          </td>
                          <td>
                            {item.active ? (
                              <span style={{
                                padding: "4px 10px",
                                borderRadius: 6,
                                background: "#f6ffed",
                                color: "#52c41a",
                                fontWeight: 700,
                                fontSize: 15
                              }}>
                                Active
                              </span>
                            ) : (
                              <span style={{
                                padding: "4px 10px",
                                borderRadius: 6,
                                background: "#fff1f0",
                                color: "#ff4d4f",
                                fontWeight: 700,
                                fontSize: 15
                              }}>
                                Inactive
                              </span>
                            )}
                          </td>
                          <td>
                            <ul className="admin-action btn btn-default" style={{
                              background: "#f8fafb",
                              border: "none",
                              padding: "2px 4px",
                              borderRadius: 8,
                              minWidth: 90,
                              boxShadow: "0 2px 8px #1677ff09"
                            }}>
                              <li role="presentation">
                                    <Link
                                      role="menuitem"
                                      tabIndex={-1}
                                      to={`/admin/ViewUser?id=${item._id}`}
                                      style={{
                                        color: "#1677ff",
                                        fontWeight: 600,
                                        fontSize: 15,
                                        padding: "5px 15px",
                                        borderRadius: 7,
                                        display: "block"
                                      }}
                                    >
                                      View
                                    </Link>
                                  </li>
                            </ul>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                {/* Pagination */}
                <div className="row">
                  <div className="col-md-5">
                    <ul className="pagination" style={{
                      display: "flex",
                      gap: 8,
                      marginTop: 8
                    }}>
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                        style={{ display: "inline-block" }}
                      >
                        <button
                          onClick={() => handlePagination(currentPage - 1)}
                          className="page-link"
                          disabled={currentPage === 1}
                          style={{
                            background: currentPage === 1 ? "#e4eaf0" : "#1677ff",
                            color: currentPage === 1 ? "#888" : "#fff",
                            border: "none",
                            borderRadius: 7,
                            fontWeight: 700,
                            fontSize: 16,
                            padding: "7px 18px",
                            boxShadow: "0 1px 6px #1677ff1b",
                            cursor: currentPage === 1 ? "not-allowed" : "pointer",
                            transition: "background 0.17s"
                          }}
                        >
                          Previous
                        </button>
                      </li>
                      <li
                        className={`page-item ${currentPage === Math.ceil(count / entriesPerPage) ? "disabled" : ""}`}
                        style={{ display: "inline-block" }}
                      >
                        <button
                          onClick={() => handlePagination(currentPage + 1)}
                          className="page-link"
                          disabled={currentPage === Math.ceil(count / entriesPerPage)}
                          style={{
                            background: currentPage === Math.ceil(count / entriesPerPage) ? "#e4eaf0" : "#1677ff",
                            color: currentPage === Math.ceil(count / entriesPerPage) ? "#888" : "#fff",
                            border: "none",
                            borderRadius: 7,
                            fontWeight: 700,
                            fontSize: 16,
                            padding: "7px 18px",
                            boxShadow: "0 1px 6px #1677ff1b",
                            cursor: currentPage === Math.ceil(count / entriesPerPage) ? "not-allowed" : "pointer",
                            transition: "background 0.17s"
                          }}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-5">
                    <div className="total-entries" style={{
                      float: "right", marginTop: "20px",
                      color: "#234", fontWeight: 700, fontSize: 17
                    }}>
                      Total entries: <b>{count}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default User;
